import { GET } from '../../_http';
import type { operations } from '@/types/schemas/api.main';
type controller = operations['CrmUserCurrentUserController_get'];

export type CrmCurrentUserResponse = controller['responses']['200']['content']['application/json'];

export const currentUser = GET('/crm/user/current-user')<CrmCurrentUserResponse>;
